
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicSelectableComponent } from 'ionic-selectable';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../models/user-profile.model';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { HomeService } from '../home/home.service';
import { RoleAccess } from '../../models/role-access.model';
import { UserData } from '../../providers/user-data';
import { Router } from '@angular/router';
import { MyService } from '../../service/my.service';
import { SetupMembershipComponent } from '../../component/setup-membership/setup-membership.component';
@Component({
  selector: 'app-setup-membership',
  templateUrl: './setup-membership.page.html',
  styleUrls: ['./setup-membership.page.scss'],
})
export class SetupMembershipPage implements OnInit {
  roleAccess = new RoleAccess();
  userAccess: any[] = [];
  dataSetupPoin: any[] = [];
  dataSetupReminder: any[] = [];
  token: any;
  userProfile: UserProfile = new UserProfile();
  constructor(
    private storage: Storage,
    private toastCtrl: ToastController,
    private navCtrl : NavController,
    private utilService : UtilService,
    private homeService: HomeService,
    private modalController : ModalController,
    private userData: UserData,
    private router: Router,
    private myService:MyService,
    private alertController :AlertController
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile,access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        window.dispatchEvent(new CustomEvent('user:getmenu'));
        this.roleAccess = this.userData.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.getDataSetupMembership();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  getDataSetupMembership() {
    this.dataSetupPoin = [];
    this.dataSetupReminder = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token
      };
      this.homeService.getMembershipSetting(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.dataSetupPoin=  response.results.data;
        this.dataSetupReminder = response.results.setupReminder;
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  
  deleteReminder(id:any) {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "id":id
      };
      this.homeService.deleteReminder(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.getDataSetupMembership();
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  
  async showConfirmDelete(id: any) {
    const alert = await this.alertController.create({
      header: 'Send Approval Confirmation',
      cssClass:'custom-alert-class',
      message: 'Apakah anda yakin untuk menghapus reminder ini?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {}
        },
        {
          text: 'Ya',
          handler: () => {
            this.deleteReminder(id);
          }
        }
      ]
    });

    await alert.present();
  }
   async goToReminderSettingComponent(id:any, notifTime:any,timeType:any,timing:any) {
      const modal = await this.modalController.create({
        component: SetupMembershipComponent,
        componentProps: {
          id:id,
          notifTime:notifTime,
          timeType:timeType,
          timing:timing,
          formType:'reminder'
        },
        backdropDismiss: false
      });
  
      modal.onDidDismiss().then((modelData) => {
        let data = modelData.data;
        if (data !== '') {
          let options = {
            "token": this.token,
            "id":id,
            "notif_time":data.notifTime ? this.myService.removeSeparator(data.notifTime) : 0,
            "time_type":data.timeType ? data.timeType : 'day',
            "timing":data.timing ? data.timing : 'otd',
            "module":"birthday_voucher"
          };
          this.homeService.saveSetupReminder(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            if(response.status.code === 200) {
              this.getDataSetupMembership();
            } else {
              this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
            }
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        }
      });
  
      return await modal.present();
    }
   async goToMembershipSettingComponent(id:any, setupName:any,setupValue:any,setupValueType:any,description:any) {
      const modal = await this.modalController.create({
        component: SetupMembershipComponent,
        componentProps: {
          id:id,
          setupName:setupName,
          setupValue:setupValue,
          setupValueType:setupValueType,
          description:description,
          formType:'point'
        },
        backdropDismiss: false
      });
  
      modal.onDidDismiss().then((modelData) => {
        let data = modelData.data;
        if (data !== '') {
          let options = {
            "token": this.token,
            "id":id,
            "setup_value":data.setupValue ? this.myService.removeSeparator(data.setupValue) : 0,
            "setup_value_type":data.setupValueType ? data.setupValueType : 'other',
            "description":data.description ? data.description : ''
          };
          this.homeService.saveMembershipSetting(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            this.getDataSetupMembership();
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        }
      });
  
      return await modal.present();
    }
}
